<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-park-invitation-manage-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .1}"
   :isFreez="isFreezModal"
   :couldOverlaySwipeClose="false"
   contentTransitionName="trans-content"

   @afterEnterContent="handleEnterContent"
   @afterLeaveContent="handleAterLeaveContent"
  >
    <div class="pa-wide-modal-box-wrapper pa-park-invitation-manage-modal-view">
      <div class="pa-wide-modal-box" ref="wideModalBox">
        <div class="pa-header" ref="paHeader">
          <div class="pa-header-box">
            <div class="pa-title">
              ひろば通行手形の管理
            </div>
            <div class="pa-description">
              <p>ひろばに参加するための通行手形の発行・管理を行うことができます。ひろばへの参加を希望する異界渡航者に対して通行手形の番号を御教え下さい。</p>
            </div>
          </div>
          <div class="pa-button-box">
            <button
            class="button pa-issue-button"
            :class="additionalIssueButtonClass"
            :disabled="isDisabledIssueButton"
            @click.prevent="handleClickIssueCode"
            >通行手形を新規発行</button>
          </div>
          <div class="content-title-box">
            <p>発行済み手形一覧</p>
          </div>
        </div>
        <div class="pa-content" ref="paContent">
          <ul class="code-list">
            <li v-for="item in invitationList" :key="item.id">
              <PAParkInvitationBanner
               :parkInvitationId="item.id"
               @onDeleteInvitation="handleDeleteInvitation"
              />
            </li>
          </ul>
          <div class="empty-code-list-view" v-if="isEmptyCodeList">
            <ParkTicket class="pa-icon" />
            <p class="pa-caption">通行手形は発行されていません。</p>
          </div>
        </div>
        <div class="pa-cancel-wrapper" ref="paCancel">
          <div class="pa-cancel">
            <button
            class="button pa-cancel-button"
            :class="cancelButtonClass"
            :disabled="isDisabledCancelButton"
            @click.prevent="handleCloseModal"
            >閉じる</button>
          </div>
        </div>
      </div>

      <transition name="pa-simple-fade" @beforeEnter="handleBeforeEnterLoading">
        <div class="pa-loading-set" v-if="isLoading">
          <div class="pa-loading-field" ref="loadingContent">
            <PuffLoadingImage stroke="#957E63" />
          </div>
          <div class="pa-loading-overlay" ref="loadingOverlay"></div>
        </div>

      </transition>
    </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PuffLoadingImage from '@/components/Pages/Connections/ConnectionApp/Images/puff.svg?inlineN'


import ParkTicket from '@/components/Pages/Parks/Detail/Images/park-ticket.svg?inlineN'

import PAParkInvitationBanner from '@/components/Pages/Parks/Detail/PAParkInvitationBanner.vue'

import {GetParkInvitationList, GetParkInvitation} from '@/graphql/queries/Park.graphql'
import {CreateInvitationCode} from '@/graphql/mutations/Park.graphql'

export default {
  props : {
    parkId  : {
      default: null
    },
  },

  components : {
    PaOverlayModal,

    PuffLoadingImage,

    PAParkInvitationBanner,

    ParkTicket
  },

  data(){
    return {
      enterdContent   : false,

      shouldOpenModal : false,

      isOpenModal   : false,
      isFreezModal  : true,

      cancelButtonClass         : [],
      isDisabledCancelButton    : false,

      isLoadingIssueButton        : false,
      additionalIssueButtonClass  : {
        'is-loading'  : false,
      },
      isDisabledIssueButton       : false,

      invitationList      : [],
      first               : 10,
      page                : 1,

      isEmptyCodeList     : false
    }
  },

  apollo : {
    parkInvitations: {
      query: GetParkInvitationList,

      variables(){
        return {
          parkId  : this.parkId,
          first   : this.first,
          page    : this.page,
          orderBy : [
            {
              column : 'expire_at',
              order : 'DESC'
            }
          ]
        };
      },

      result({data: {parkInvitations: {data}}}){

        const apolloClient = this.$apollo.provider.defaultClient;

        for(let item of data){
          apolloClient.writeQuery({
            query     : GetParkInvitation,
            variables : {
              id  : item.id
            },
            data      : {
              parkInvitation : item
            }
          });
        }
      },

      skip(){
        if((this.isMountedLoginedViewPage === true) && (this.enterdContent === true)){
          return false;
        }else{
          return true;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },

      fetchPolicy: 'no-cache'
    }
  },

  computed : {
    urlQuery(){
      return this.$route.query;
    },

    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    },

    isLoading(){
      return this.$apollo.queries.parkInvitations.loading;
    },
  },

  watch : {
    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        if(typeof data.open_invitation_manage_modal !== 'undefined'){
          this.shouldOpenModal = true;
        }else{
          this.shouldOpenModal = false;
        }
      },
      immediate: true,
      deep: true
    },

    shouldOpenModal : {
      handler(value){
        if( (value === true) && (this.isMountedLoginedViewPage === true) ){
          this.isOpenModal = true;
        }else{
          this.isOpenModal = false;
        }
      },
      immediate: true
    },

    isMountedLoginedViewPage : {
      handler(value){
        if( (value === true) && (this.shouldOpenModal === true) ){
          this.isOpenModal = true;
        }else{
          this.isOpenModal = false;
        }
      },
      immediate: true
    },

    isLoadingIssueButton  : {
      handler(value){
        this.isDisabledIssueButton = value;
        this.additionalIssueButtonClass['is-loading'] = value;
      },
      immediate: true
    },

    parkInvitations : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.insertInvitationList(data);
      },
      deep: true,
      immediate: true
    },

    invitationList  : {
      handler(data){
        if(data.length === 0){
          this.isEmptyCodeList = true;
        }else{
          this.isEmptyCodeList = false;
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods : {
    insertInvitationList(data){
      const parameters = {
        requestBehaviour  : 'next',
        invitationList    : [],

        pageSet           : {
          page        : null,
          lastPage    : null,
          total       : null,
        }
      };

      if(this.page === 1){
        parameters.requestBehaviour = 'refresh';
      }

      for(let invitation of data.data){
        parameters.invitationList.push({
          id  : invitation.id
        });
      }

      if(typeof data.paginatorInfo !== 'undefined'){
        parameters.pageSet.page     = data.paginatorInfo.currentPage;
        parameters.pageSet.lastPage = data.paginatorInfo.lastPage;
        parameters.pageSet.total    = data.paginatorInfo.total;
      }

      if(parameters.requestBehaviour === 'refresh'){
        this.invitationList = parameters.invitationList;
      }else{
        for(let invitation of parameters.invitationList){
          let couldRegist = true;

          for(let registerdInvitation of this.invitationList){
            if(registerdInvitation.id === invitation.id){
              couldRegist = false;
            }
          }

          if(couldRegist){
            this.invitationList.push({
              id  : invitation.id
            });
          }
        }
      }
    },

    handleEnterContent(){
      this.setModalContentHeight();

      this.enterdContent = true;
    },

    handleAterLeaveContent(){
      this.invitationList = [];
      this.page = 1;
      
      this.enterdContent = false;
    },

    handleBeforeEnterLoading(){
      const boxHeight = this.$refs.wideModalBox.offsetHeight;

      this.$refs.loadingContent.style.height = boxHeight + 'px';
      this.$refs.loadingOverlay.style.height = boxHeight + 'px';
    },

    setModalContentHeight(){
      const maxTime   = 50;
      let timeCounter = 0;

      const intervalTimer = setInterval(() => {
        const windowHeight = window.innerHeight;

        const actualBoxHeight = windowHeight - (windowHeight * .25);

        const headerHeight  = this.$refs.paHeader.offsetHeight;
        const cancelHeight  = this.$refs.paCancel.offsetHeight;

        timeCounter++;

        if(timeCounter > maxTime){
          clearInterval(intervalTimer);
        }

        if(actualBoxHeight === 0) return;

        const contentHeight = actualBoxHeight - (headerHeight + cancelHeight);

        this.$refs.paContent.style.height = contentHeight+'px';

        clearInterval(intervalTimer);
      }, 100);
    },

    handleCloseModal(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      if(newUrlQuery['y'] === 0){
        delete newUrlQuery.y;
      }

      delete newUrlQuery.open_invitation_manage_modal;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    async handleClickIssueCode(){
      this.isLoadingIssueButton = true;

      await this.UXWaiting(500);
      
      await this.executeIssueCode();

      this.isLoadingIssueButton = false;
    },

    executeIssueCode(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : CreateInvitationCode,
          variables : {
            parkId  : this.parkId
          }
        }).then(async () => {
          this.$apollo.queries.parkInvitations.refetch();
          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);
          
          if(typeof errorSet.first !== 'undefined'){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;通行手形は有効な手形を５個以上発行することができません。',
              status      : 'error',
              hasControl  : true,
              autoClose   : 8000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    handleDeleteInvitation(){
      this.$apollo.queries.parkInvitations.refetch();
      
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-park-invitation-manage-modal-view{
  position: relative;

  .pa-wide-modal-box{
    overflow: hidden;

    .pa-header{
      box-sizing:border-box;
      background-color: inherit;

      .pa-header-box{
        background-color: #CCAA8B;

        div.pa-description{
          p{
            text-align: center;
            font-size:.85rem;
            line-height: 1.2rem;

            @include until(375px) {
            font-size:.75rem;
            line-height: 1rem;
            }
          }
        }
      }

      .pa-button-box{
        padding:.9rem 0;
        border-bottom:1px solid #C6AA89;

        @include until(375px) {
          padding:.5rem 0;
        }

        button.pa-issue-button{
          display: block;
          border:0;
          margin:0 auto;
          padding:2px 4px;
          width:70%;
          height:inherit;
          background-color: #CA8534;
          color:#ECC496;
          letter-spacing: 1.5px;

          transition:border-bottom .25s ease-in-out;
          transition:font-weight .25s ease-in-out;
          transition:color .25s ease-in-out;

          @include until(375px) {
            font-size: .85rem;
          }

          &.is-loading{
            &::after{
              border: 1.3px solid #ECC496;
              border-right-color: transparent;
              border-top-color: transparent;
            }
          }
        }
      }

      .content-title-box{
        padding:.5rem 0 0;
        p{
          font-size:1rem;
          text-align: center;
          color:#AA8D69;

          @include until(375px) {
            font-size:.9rem;
          }
        }
      }
    }

    .pa-content{
      overflow-y: scroll;
      position: relative;

      ul.code-list{
        li{
          width:95%;
          margin:0 auto 1rem;

          &:last-child{
            margin-bottom: 0;
          }
        }
      }

      .empty-code-list-view{
        position: absolute;
        width:100%;
        height:100%;
        top:0;
        left:0;

        svg.pa-icon{
          display:block;
          margin:3rem auto 0;
          width:12rem;
          height:auto;

          .a{fill:#cab090;}
          .b{fill:#BB9C77;}
          // .a{fill:#cab090;}.b{fill:#917353;}
        }

        p.pa-caption{
          margin-top:1rem;
          font-size:1rem;
          text-align: center;
          color:#b1916a;
          letter-spacing: 1px;
        }
      }
    }

    .pa-cancel-wrapper{
      box-sizing:border-box;
      padding-top:.5rem;
      padding-bottom:1rem;

      .pa-cancel{
        box-sizing:border-box;

        margin-top:0;
        border-top:1px solid #C6AA89;
        text-align: center;

        button{
          margin-top:.4rem;
          font-size:1.2rem;
          font-weight: normal;

          @include until(375px) {
            font-size:1rem;
          }
        }
      }
    }
  }

  .pa-loading-set{
    .pa-loading-field, .pa-loading-overlay{
      z-index: 1;
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:500px;
      text-align: center;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;align-items: center;
    }

    .pa-loading-overlay{
      z-index:0;
      background:linear-gradient(0deg, rgba($body-background-darker, .7), rgba($body-background-darker, .5));
      backdrop-filter: blur(3px) opacity(.9);
    }
  }
}
</style>